import React from "react";
import {
  Box,
  Button,
  Icon,
  InlineStack,
  BlockStack,
} from "@shopify/polaris";
import { AddMajor } from "@shopify/polaris-icons";
import LazyLoad from "react-lazyload";
import intl from "../../../../i18n/intl";
import ProductAddIcon from '../../SubscriptionPaid/components/icons/ProductAddIcon'
const ListItem = ({ data ,handleToSourcingList ,handleJumpToDetail,linkPage,cateId}) => {
  return (
    <Box className="product-list">
      {data.map((item, key) => (
        <Box className="find-product-item" key={key}>
          <Box className="product-item">
            <Box className="product-tp" onClick={()=>handleJumpToDetail(item.record_id,linkPage,cateId)}>
              <Box className="product-tp-img">
                <LazyLoad
                  scroll={true}
                  placeholder={
                    <img
                    width={56}
                    height={56}
                      className="defalut_product_loading"
                      style={{ borderRadius: "10px" }}
                      src={"/new-product/defalut_product.png"}
                      alt="DropShipMan"
                    />
                  }
                >
                  <img
                    className="product_img"
                    src={item?.product_image[0]}
                    alt="DropShipMan"
                  />
                </LazyLoad>
                {/* <Box className="product-tp-mask">
                  <LazyLoad
                    scroll={true}
                    placeholder={
                      <img
                        width={"100%"}
                        height={"100%"}
                        style={{ borderRadius: "10px" }}
                        src={"/default_image.png"}
                        alt="DropShipMan"
                      />
                    }
                  >
                    <img src={item?.product_image[1]} alt="DropShipMan" />
                  </LazyLoad>
                </Box> */}
              </Box>
            </Box>
            <Box className="product-mid">
              <Box className="product-content">
                <BlockStack gap={200}>
                  <Box className="product-title product-title-truncate" title={item.title}>
                    {item.title}
                  </Box>
                  <Box className="product-rate">
                    <Box>
                      <InlineStack align="space-between">
                        <span className="product-rate-item">
                          <svg viewBox="0 0 20 20">
                            <path d="M5.2 18a.8.8 0 0 1-.792-.914l.743-5.203-2.917-2.917a.8.8 0 0 1 .434-1.355l4.398-.733 2.218-4.435a.8.8 0 0 1 1.435.008l2.123 4.361 4.498.801a.8.8 0 0 1 .425 1.353l-2.917 2.917.744 5.203a.8.8 0 0 1-1.154.828l-4.382-2.22-4.502 2.223A.792.792 0 0 1 5.2 18z"></path>
                          </svg>
                          {item.rating + " (" + item.review_count + ")"}
                        </span>
                        <span className="product-order-item">
                          {/* <svg viewBox="0 0 20 20">
                            <path d="M11 1a1 1 0 1 0-2 0v7.586L7.707 7.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 8.586V1z"></path>
                            <path d="M3 14V3h4V1H2.5A1.5 1.5 0 0 0 1 2.5v15A1.5 1.5 0 0 0 2.5 19h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 17.5 1H13v2h4v11h-3.5c-.775 0-1.388.662-1.926 1.244l-.11.12A1.994 1.994 0 0 1 10 16a1.994 1.994 0 0 1-1.463-.637l-.111-.12C7.888 14.664 7.275 14 6.5 14H3z"></path>
                          </svg> */}
                          <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M3.97553 0.5C2.6124 0.5 1.45499 1.49858 1.25522 2.84699L0.59447 7.30708C0.531575 7.73161 0.5 8.1602 0.5 8.58938V10.25C0.5 12.0449 1.95507 13.5 3.75 13.5H10.25C12.0449 13.5 13.5 12.0449 13.5 10.25V8.58938C13.5 8.1602 13.4684 7.73161 13.4055 7.30708L12.7448 2.84699C12.545 1.49858 11.3876 0.5 10.0245 0.5H3.97553ZM2.73903 3.06681C2.82983 2.4539 3.35593 2 3.97553 2H10.0245C10.6441 2 11.1702 2.4539 11.261 3.06681L11.8437 7H9.36038C8.82234 7 8.34467 7.34429 8.17453 7.85472L8.01641 8.32906C7.98238 8.43114 7.88685 8.5 7.77924 8.5H6.22076C6.11315 8.5 6.01762 8.43114 5.98359 8.32906L5.82547 7.85472C5.65533 7.34429 5.17766 7 4.63962 7H2.15633L2.73903 3.06681ZM2.00055 8.5C2.00018 8.52979 2 8.55958 2 8.58938V10.25C2 11.2165 2.7835 12 3.75 12H10.25C11.2165 12 12 11.2165 12 10.25V8.58938C12 8.55958 11.9998 8.52979 11.9994 8.5H9.54057L9.43944 8.8034C9.20124 9.518 8.53249 10 7.77924 10H6.22076C5.46751 10 4.79876 9.518 4.56056 8.8034L4.45943 8.5H2.00055Z" fill=""/>
                          </svg>
                          {" " + item.order_count}
                        </span>
                      </InlineStack>
                    </Box>
                  </Box>
                  <Box className="product-price">
                    <span><b>$</b><strong>{item.price}</strong></span>
                  </Box>
                </BlockStack>
                
              </Box>
            </Box>
            {item.dsm_pid === 0 ? <Box className="product-bt_mob" onClick={(e) => {
                    e.stopPropagation();
                    handleToSourcingList(key, item.record_id, item.pid,0)
                  }}>
                    <ProductAddIcon />
            </Box> : <Box className="is_add_product">
                <img src="/new-product/added.png" alt="Dropshipman" />
                </Box>}
            <Box className="product-bt">
              <Box className="product-btn">
                {item.dsm_pid ? (
                  <Button
                    onClick={() =>
                      handleToSourcingList(key, item.record_id, item.pid,item.dsm_pid)
                    }
                  >
                    {intl.get("Edit on product list")}
                  </Button>
                ) : (
                  <Button variant="primary" loading={item.loading} onClick={() =>
                    handleToSourcingList(key, item.record_id, item.pid,0)
                  }>
                    <InlineStack blockAlign="center">
                      <Icon source={AddMajor} tone="base" />{" "}
                      {intl.get("Add to product list")}
                    </InlineStack>
                  </Button>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default ListItem;
